(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-model"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('model-list')) {
    class ModelList extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.grid = this.querySelector('[data-model-items]');
        if (!this.grid) return;

        this.cards = Array.from(this.grid.querySelectorAll('[data-model-card]')).map((el) => ({
          el,
          index: 0,
          id: el.dataset.collectionId || '',
          vendor: el.dataset.vendor || '',
          type: el.dataset.type || '',
          price: parseInt(el.dataset.price, 10) || 0,
          count: parseInt(el.dataset.count, 10) || 0,
          title: el.dataset.title || '',
          search: el.dataset.search || '',
        }));

        this.assignRecommendedOrder();

        this.controls = {};
        this.querySelectorAll('[data-model-control]').forEach((control) => {
          this.controls[control.dataset.modelControl] = control;
        });

        this.readUrl();

        let timer;
        Object.entries(this.controls).forEach(([key, control]) => {
          if (key === 'q') {
            control.addEventListener('input', () => {
              clearTimeout(timer);
              timer = setTimeout(() => this.apply(), 150);
            });
          } else {
            control.addEventListener('change', () => this.apply());
          }
        });

        const reset = this.querySelector('[data-model-reset]');
        if (reset) reset.addEventListener('click', () => this.reset());

        this.apply(false);
      }

      /*
        Sortierung "Empfohlen": bis zu 4 ausgewählte Modelle zuerst (in der gewählten
        Reihenfolge), alle übrigen bei jedem Seitenaufruf zufällig gemischt.
      */
      assignRecommendedOrder() {
        const featured = (this.dataset.featured || '').split(',').filter(Boolean);
        const rest = this.cards.filter((card) => !featured.includes(card.id));
        for (let i = rest.length - 1; i > 0; i -= 1) {
          const j = Math.floor(Math.random() * (i + 1));
          [rest[i], rest[j]] = [rest[j], rest[i]];
        }
        const pinned = featured
          .map((id) => this.cards.find((card) => card.id === id))
          .filter(Boolean);
        pinned.concat(rest).forEach((card, position) => {
          card.index = position;
        });
      }

      value(key) {
        const control = this.controls[key];
        return control ? control.value.trim() : '';
      }

      test(key, value, card) {
        if (!value) return true;
        switch (key) {
          case 'q':
            return value
              .toLowerCase()
              .split(/\s+/)
              .every((word) => card.search.includes(word));
          case 'vendor':
            return card.vendor === value;
          case 'type':
            return card.type === value;
          case 'price': {
            const [low, high] = value.split('-');
            const min = parseInt(low, 10) || 0;
            const max = high ? parseInt(high, 10) : Infinity;
            return card.price >= min && card.price < max;
          }
          default:
            return true;
        }
      }

      matches(card, except) {
        return ['q', 'vendor', 'type', 'price'].every(
          (key) => key === except || this.test(key, this.value(key), card)
        );
      }

      sortCards(cards) {
        const sort = this.value('sort');
        const sorted = cards.slice();
        const byIndex = (a, b) => a.index - b.index;
        switch (sort) {
          case 'price-asc':
            return sorted.sort((a, b) => a.price - b.price || byIndex(a, b));
          case 'price-desc':
            return sorted.sort((a, b) => b.price - a.price || byIndex(a, b));
          case 'title':
            return sorted.sort((a, b) => a.title.localeCompare(b.title, document.documentElement.lang || 'de'));
          case 'count':
            return sorted.sort((a, b) => b.count - a.count || byIndex(a, b));
          default:
            return sorted.sort(byIndex);
        }
      }

      apply(updateUrl = true) {
        const visible = this.cards.filter((card) => this.matches(card));

        this.sortCards(this.cards).forEach((card) => this.grid.appendChild(card.el));
        this.cards.forEach((card) => {
          card.el.hidden = !visible.includes(card);
        });

        const count = this.querySelector('[data-model-count]');
        if (count) {
          const template = visible.length === 1 ? count.dataset.one : count.dataset.other;
          count.textContent = (template || '').replace('[count]', visible.length);
        }

        const empty = this.querySelector('[data-model-empty]');
        if (empty) empty.hidden = visible.length > 0;
        this.grid.hidden = visible.length === 0;

        this.updateOptions();
        if (updateUrl) this.writeUrl();
      }

      // Optionen ohne Treffer ausgrauen – die Filter selbst bleiben immer stehen
      updateOptions() {
        ['vendor', 'type', 'price'].forEach((key) => {
          const control = this.controls[key];
          if (!control) return;
          const pool = this.cards.filter((card) => this.matches(card, key));
          Array.from(control.options).forEach((option) => {
            if (!option.value) return;
            const hits = pool.some((card) => this.test(key, option.value, card));
            option.disabled = !hits && !option.selected;
          });
        });
      }

      reset() {
        Object.values(this.controls).forEach((control) => {
          control.value = '';
        });
        this.apply();
      }

      readUrl() {
        const params = new URLSearchParams(window.location.search);
        Object.entries(this.controls).forEach(([key, control]) => {
          const value = params.get(key);
          if (!value) return;
          if (control.tagName === 'SELECT' && !Array.from(control.options).some((o) => o.value === value)) return;
          control.value = value;
        });
      }

      writeUrl() {
        const url = new URL(window.location.href);
        Object.entries(this.controls).forEach(([key, control]) => {
          const value = control.value.trim();
          if (value) url.searchParams.set(key, value);
          else url.searchParams.delete(key);
        });
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }

    customElements.define('model-list', ModelList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-model"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('model-collection')) {
    class ModelCollection extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.mediaCache = new Map();
        this.pending = new Map();
        this.sectionCache = new Map();
        this.expanded = false;

        this.readUnits();
        // Beim Laden ist kein Einzelstück ausgewählt (außer der Browser stellt eine Auswahl wieder her)
        this.current = this.units.find((u) => u.input && u.input.checked) || null;

        this.bindEvents();
        this.bindGallery();
        const gallery = this.querySelector('[data-gallery]');
        this.galleryProductId = gallery ? parseInt(gallery.dataset.galleryProduct, 10) || null : null;
        this.bindStickyOffset();
        this.bindBanner();
        if (this.current) this.select(this.current);
        else this.showDefault();
        this.updateList();
        this.updateHints();
        this.revealActivePills();
      }

      /*
        Infobox unter der Galerie: ausführliche Infos des gewählten Einzelstücks aus
        snippets/model-unit-info.liquid (pro Stück vorgerendert in <template data-unit-details>).
        Ohne Auswahl der Platzhaltertext aus den Einstellungen, ohne Inhalt wird die Box ausgeblendet.
      */
      renderInfobox(data) {
        const box = this.querySelector('[data-model-infobox]');
        if (!box) return;
        const target = box.querySelector('[data-infobox-text]');
        if (!target) return;
        const unit = data ? this.units.find((u) => u.data === data) : null;
        const source = unit ? unit.el.querySelector('[data-unit-details]') : box.querySelector('[data-infobox-placeholder]');
        box.classList.toggle('is-placeholder', !data);
        target.innerHTML = source ? source.innerHTML.trim() : '';
        box.hidden = target.textContent.trim() === '';
        this.updateBannerSpace();
      }

      /*
        Mobil ist die Infobox ein fixierter Banner unten. Damit er nichts verdeckt, bekommt die
        Seite unten so viel Abstand wie der Banner hoch ist. Statt eines Schließen-Buttons
        enthält er einen Warenkorb-Button (nur wenn der Block „Warenkorb-Button“ existiert).
      */
      bindBanner() {
        const box = this.querySelector('[data-model-infobox]');
        if (!box) return;
        this.bannerQuery = window.matchMedia('(max-width: 749px)');
        const cart = box.querySelector('[data-add-button-mobile]');
        if (cart && !document.getElementById(cart.getAttribute('form'))) cart.hidden = true;
        if (window.ResizeObserver) new ResizeObserver(() => this.updateBannerSpace()).observe(box);
        this.bindBannerScroll(box);
        const onChange = () => this.updateBannerSpace();
        if (this.bannerQuery.addEventListener) this.bannerQuery.addEventListener('change', onChange);
        else if (this.bannerQuery.addListener) this.bannerQuery.addListener(onChange);
      }

      // Mobil: Banner beim Hochscrollen ausblenden, beim Runterscrollen wieder einblenden
      bindBannerScroll(box) {
        let lastY = window.scrollY;
        let frame;
        const update = () => {
          frame = null;
          const y = window.scrollY;
          const delta = y - lastY;
          if (Math.abs(delta) < 16) return;
          lastY = y;
          if (!this.bannerQuery.matches) {
            box.classList.remove('is-scroll-hidden');
            return;
          }
          box.classList.toggle('is-scroll-hidden', delta < 0);
        };
        window.addEventListener('scroll', () => {
          if (!frame) frame = requestAnimationFrame(update);
        }, { passive: true });
      }

      updateBannerSpace() {
        const box = this.querySelector('[data-model-infobox]');
        if (!box || !this.bannerQuery) return;
        const visible = this.bannerQuery.matches && !box.hidden && window.getComputedStyle(box).display !== 'none';
        document.body.style.paddingBottom = visible ? `${box.offsetHeight}px` : '';
      }

      /* ---------- Sticky-Galerie: Abstand zum sichtbaren Header ---------- */
      bindStickyOffset() {
        if (!this.classList.contains('model-collection--sticky')) return;
        const header = document.querySelector('.section-header, .shopify-section-group-header-group, sticky-header');
        if (!header) return;
        let frame;
        const update = () => {
          frame = null;
          const style = window.getComputedStyle(header);
          const isSticky = style.position === 'sticky' || style.position === 'fixed';
          const bottom = isSticky ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
          this.style.setProperty('--model-sticky-top', `${Math.round(bottom) + 20}px`);
        };
        const schedule = () => {
          if (!frame) frame = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);
        update();
      }

      /* ---------- Einzelstücke ---------- */
      readUnits() {
        this.list = this.querySelector('[data-units-list]');
        this.initialCount = this.list ? parseInt(this.list.dataset.initialCount, 10) || 4 : 4;
        this.initialCountMobile = this.list ? parseInt(this.list.dataset.initialCountMobile, 10) || 2 : 2;
        this.bindPeek();
        this.units = Array.from(this.querySelectorAll('[data-unit]')).map((el) => {
          let data = {};
          try {
            data = JSON.parse(el.querySelector('[data-unit-json]').textContent);
          } catch (e) {}
          return { el, input: el.querySelector('[data-unit-input]'), data };
        });
      }

      bindEvents() {
        this.addEventListener('change', (event) => {
          const target = event.target;
          if (target.matches('[data-unit-input]')) {
            const unit = this.units.find((u) => u.input === target);
            if (unit && target.checked) this.select(unit);
          } else if (target.closest('[data-model-filters]')) {
            this.applyFilters();
          }
        });

        this.addEventListener('click', (event) => {
          // Pro Filter höchstens ein Wert: Klick auf den aktiven Chip wählt ihn wieder ab
          const pillLabel = event.target.closest('[data-model-filters] label');
          if (pillLabel) {
            const input = pillLabel.control;
            if (input && input.type === 'radio' && input.checked) {
              event.preventDefault();
              input.checked = false;
              this.applyFilters();
            }
            return;
          }

          const clear = event.target.closest('[data-filter-clear]');
          if (clear) {
            event.preventDefault();
            const group = clear.closest('[data-model-filters]');
            if (group) group.querySelectorAll('input[type="radio"]').forEach((input) => (input.checked = false));
            this.applyFilters();
            return;
          }

          const reset = event.target.closest('[data-filter-reset]');
          if (reset) {
            event.preventDefault();
            const sortBy = new URL(reset.href, window.location.href).searchParams.get('sort_by');
            this.loadResults(sortBy ? `sort_by=${encodeURIComponent(sortBy)}` : '');
            return;
          }

          if (event.target.closest('[data-units-more]')) {
            this.expanded = !this.expanded;
            this.updateList();
          }
        });

        this.addEventListener('pointerover', (event) => {
          const el = event.target.closest('[data-unit]');
          if (!el || el.dataset.prefetched) return;
          el.dataset.prefetched = 'true';
          const unit = this.units.find((u) => u.el === el);
          if (unit) this.prefetch(unit.data);
        });
      }

      // Anzahl voll sichtbarer Kacheln im eingeklappten Zustand (mobil / ab Tablet)
      visibleCount() {
        return window.matchMedia('(max-width: 749px)').matches ? this.initialCountMobile : this.initialCount;
      }

      // Spalten des Rasters (mobil 1, ab Tablet 2)
      listColumns() {
        if (!this.list) return 1;
        const columns = window.getComputedStyle(this.list).gridTemplateColumns || '';
        return Math.max(1, columns.split(' ').filter(Boolean).length);
      }

      updateList() {
        // Eingeklappt: "count" Kacheln voll sichtbar, darunter eine angeschnittene Reihe als Vorschau.
        // Liegt das gewählte Stück weiter hinten, ersetzt es den letzten vollen Platz.
        const count = this.visibleCount();
        const currentIndex = this.units.indexOf(this.current);
        const lastSlot = currentIndex >= count ? count - 1 : count;
        const full = this.units.filter((unit, index) => this.expanded || index < lastSlot || unit === this.current);
        const peek = this.expanded ? [] : this.units.filter((unit) => !full.includes(unit)).slice(0, this.listColumns());

        this.units.forEach((unit) => {
          const isPeek = peek.includes(unit);
          unit.el.classList.toggle('is-collapsed', !full.includes(unit) && !isPeek);
          unit.el.classList.toggle('is-peek', isPeek);
          // Vorschau immer hinter den voll sichtbaren Kacheln (auch wenn das gewählte Stück weiter hinten liegt)
          unit.el.style.order = isPeek ? '1' : '';
          // Angeschnittene Kacheln sind nur Vorschau – nicht anklick- oder fokussierbar
          if (isPeek) unit.el.setAttribute('inert', '');
          else unit.el.removeAttribute('inert');
        });
        this.peekUnits = peek;
        this.updatePeekHeight();

        // Ausgeklappt: alle Einzelstücke in einem scrollbaren Container
        if (this.list) this.list.classList.toggle('is-expanded', this.expanded && this.units.length > count);
        this.updateExpandedHeight();

        const more = this.querySelector('[data-units-more]');
        if (more) {
          more.hidden = this.units.length <= count;
          more.setAttribute('aria-expanded', String(this.expanded));
          const template = this.expanded ? more.dataset.lessLabel : more.dataset.moreLabel;
          more.textContent = (template || '').replace('[count]', this.units.length);
        }
        this.updateBuyState();
      }

      // Liste so kürzen, dass die Vorschau-Reihe nur zur Hälfte zu sehen ist
      updatePeekHeight() {
        if (!this.list) return;
        const first = this.peekUnits && this.peekUnits[0];
        if (!first) {
          this.list.classList.remove('has-peek');
          this.list.style.maxHeight = '';
          this.list.style.removeProperty('--model-peek-fade');
          return;
        }
        this.list.classList.add('has-peek');
        const visiblePart = Math.round(first.el.offsetHeight * 0.5);
        this.list.style.maxHeight = `${first.el.offsetTop + visiblePart}px`;
        // Verlauf nur über den sichtbaren Teil der angeschnittenen Kachel
        this.list.style.setProperty('--model-peek-fade', `${visiblePart}px`);
      }

      // Mobil: ausgeklappter Scroll-Container 4,5 Einzelstücke hoch – das angeschnittene
      // fünfte Stück zeigt, dass sich der Container scrollen lässt
      updateExpandedHeight() {
        if (!this.list || !this.list.classList.contains('is-expanded')) return;
        const fifth = this.units[4];
        if (!window.matchMedia('(max-width: 749px)').matches || !fifth) {
          this.list.style.maxHeight = '';
          return;
        }
        this.list.style.maxHeight = `${fifth.el.offsetTop + Math.round(fifth.el.offsetHeight * 0.5)}px`;
      }

      bindPeek() {
        if (this.peekBound || !this.list) return;
        this.peekBound = true;
        let frame;
        const schedule = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => this.updateList());
        };
        window.addEventListener('resize', schedule);
        // Bilder ändern beim Laden die Kachelhöhe
        this.addEventListener('load', (event) => {
          if (event.target.tagName === 'IMG' && event.target.closest('[data-units-list]')) schedule();
        }, true);
      }

      // Mobil: gewählten Chip in seiner scrollbaren Zeile sichtbar machen
      revealActivePills() {
        this.querySelectorAll('[data-model-filters] .model-filter__options').forEach((row) => {
          if (row.scrollWidth <= row.clientWidth) return;
          const active = row.querySelector('.model-pill__input:checked + .model-pill, .model-pill.is-active');
          if (!active) return;
          const target = active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2;
          row.scrollLeft = Math.max(0, target);
        });
      }

      /* ---------- Filter (Search & Discovery) ---------- */
      currentParams() {
        const params = new URLSearchParams();
        if (this.dataset.sortBy) params.set('sort_by', this.dataset.sortBy);
        this.querySelectorAll('[data-model-filters] input[type="radio"]:checked').forEach((input) => {
          if (input.name && input.value) params.append(input.name, input.value);
        });
        return params;
      }

      applyFilters() {
        this.loadResults(this.currentParams().toString());
      }

      sectionUrl(query) {
        const base = this.dataset.url || window.location.pathname;
        return `${base}?section_id=${encodeURIComponent(this.dataset.sectionId)}${query ? `&${query}` : ''}`;
      }

      fetchSection(query, signal) {
        const url = this.sectionUrl(query);
        if (this.sectionCache.has(url)) return Promise.resolve(this.sectionCache.get(url));
        return fetch(url, { signal })
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then((html) => {
            this.sectionCache.set(url, html);
            return html;
          });
      }

      /*
        "ab"-Preise an den Filter-Chips: Für jede Option wird die Section mit der aktuellen
        Auswahl + dieser Option geladen (Search & Discovery filtert) und der günstigste Preis
        übernommen. So beachten die Preise immer alle aktiven Filter – ohne eigenes Metafeld.
      */
      updateHints() {
        const forms = Array.from(this.querySelectorAll('[data-model-filters][data-price-hints]')).filter((f) => !f.hidden);
        if (!forms.length) return;
        if (this.hintController) this.hintController.abort();
        this.hintController = new AbortController();
        const signal = this.hintController.signal;
        const fromLabel = this.dataset.fromLabel || '';
        const base = this.currentParams();
        const jobs = [];

        forms.forEach((form) => {
          const names = new Set(Array.from(form.querySelectorAll('input[type="radio"][name]')).map((i) => i.name));
          form.querySelectorAll('input[type="radio"][name]').forEach((input) => {
            const hint = input.nextElementSibling && input.nextElementSibling.querySelector('[data-price-hint]');
            if (!hint || input.disabled) return;
            if (input.checked) {
              const own = this.querySelector('[data-model-price]');
              const price = own ? own.dataset.fromPrice : '';
              hint.textContent = price ? `${fromLabel} ${price}` : '';
              return;
            }
            const params = new URLSearchParams(base);
            names.forEach((name) => params.delete(name));
            params.append(input.name, input.value);
            jobs.push({ hint, query: params.toString() });
          });
        });

        const parsePrice = (html) => {
          const match = html.match(/data-from-price="([^"]*)"/);
          if (!match || !match[1]) return '';
          return new DOMParser().parseFromString(`<p>${match[1]}</p>`, 'text/html').body.textContent.trim();
        };

        const worker = () => {
          const job = jobs.shift();
          if (!job || signal.aborted) return Promise.resolve();
          return this.fetchSection(job.query, signal)
            .then((html) => {
              if (signal.aborted) return;
              const price = parsePrice(html);
              job.hint.textContent = price ? `${fromLabel} ${price}` : '';
            })
            .catch(() => {})
            .then(worker);
        };
        // höchstens 3 Anfragen gleichzeitig
        for (let i = 0; i < 3; i += 1) worker();
      }

      loadResults(query) {
        const base = this.dataset.url || window.location.pathname;
        const pageUrl = query ? `${base}?${query}` : base;

        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const activeId = document.activeElement && this.contains(document.activeElement) ? document.activeElement.id : '';

        this.classList.add('is-filtering');
        const results = this.querySelector('[data-model-units]');
        if (results) results.setAttribute('aria-busy', 'true');

        this.fetchSection(query, this.controller.signal)
          .then((html) => {
            const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('model-collection');
            if (!fresh || !fresh.querySelector('[data-model-units]')) {
              window.location.href = pageUrl;
              return;
            }
            this.querySelectorAll('[data-model-filters]').forEach((target) => {
              const source = fresh.querySelector(`[data-model-filters="${target.dataset.modelFilters}"]`);
              if (!source) return;
              target.innerHTML = source.innerHTML;
              target.hidden = source.hidden;
            });
            ['[data-model-units]', '[data-model-price]'].forEach((selector) => {
              const target = this.querySelector(selector);
              const source = fresh.querySelector(selector);
              if (!target || !source) return;
              target.innerHTML = source.innerHTML;
              target.hidden = source.hidden;
              if (source.dataset.fromPrice !== undefined) target.dataset.fromPrice = source.dataset.fromPrice;
            });
            window.history.replaceState(window.history.state, '', pageUrl);
            this.afterResults();
            if (activeId) {
              const focusTarget = document.getElementById(activeId);
              if (focusTarget) focusTarget.focus({ preventScroll: true });
            }
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            window.location.href = pageUrl;
          })
          .finally(() => {
            this.classList.remove('is-filtering');
            const box = this.querySelector('[data-model-units]');
            if (box) box.removeAttribute('aria-busy');
          });
      }

      afterResults() {
        const previousId = this.current ? this.current.data.id : null;
        this.expanded = false;
        this.readUnits();

        // Auswahl bleibt erhalten, solange das Stück noch in der Liste ist – sonst keine Auswahl
        const keep = this.units.find((u) => u.data.id === previousId);
        if (keep) {
          keep.input.checked = true;
          this.current = keep;
          this.showUnitPrice(keep.data);
        } else {
          this.current = null;
          this.showDefault();
        }
        this.updateList();
        this.updateHints();
        this.revealActivePills();
      }

      /* ---------- Auswahl ---------- */
      // Ohne Auswahl: Galerie vom teuersten Stück, Platzhalter in der Infobox, Kauf gesperrt.
      // Preiszeile ("ab …") und Badge kommen dann direkt aus dem Server-HTML.
      showDefault() {
        const fallback = this.units.reduce((max, unit) => (!max || unit.data.price > max.data.price ? unit : max), null);
        if (fallback) this.loadGallery(fallback.data);
        this.querySelectorAll('[data-variant-input]').forEach((input) => {
          input.value = '';
        });
        // Button zum Einzelstück: ausgegraut und ohne Ziel, bis ein Stück gewählt ist
        this.querySelectorAll('[data-unit-link]').forEach((link) => {
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
        });
        this.renderInfobox(null);
        this.renderDescription(null);
        this.updateBuyState();

        const available = this.units.filter((unit) => unit.data.available);
        const cheapest = (available.length ? available : this.units).reduce(
          (min, unit) => (!min || unit.data.price < min.data.price ? unit : min),
          null
        );
        this.setPurchaseAmount(cheapest ? cheapest.data.price : null);
      }

      /*
        Klarna (App-Block "Klarna On-site Messaging"):
        Auf Kollektionsseiten setzt die App beim Start den Betrag "0" (im Theme-Editor "10998")
        und schaltet dynamische Platzierungen (z. B. credit-promotion-badge) dann auf eine
        Ersatz-Platzierung um. Danach greift sie nicht mehr ein.
        Die Section setzt deshalb an jedem <klarna-placement> in der Section:
          - data-key zurück auf den im Block gewählten Typ (aus klarnaAppBlocksManager.placements)
          - data-purchase-amount auf den eigenen Betrag (Cent)
        Klarna rendert bei Attributänderungen selbst neu. Ein MutationObserver fängt den Fall ab,
        dass die App erst nach der Section startet (mit Bremse gegen Endlosschleifen).
      */
      setPurchaseAmount(amount) {
        if (amount == null) return;
        this.purchaseAmount = String(amount);
        this.klarnaCorrections = 0;
        this.applyKlarna();
        this.watchKlarna();
      }

      klarnaKeyFor(el) {
        const manager = window.klarnaAppBlocksManager;
        const list = (manager && manager.placements) || window.appBlockPlacements || [];
        const data = list.find((placement) => placement && placement.selector === el.id);
        return data && data.dataKey ? data.dataKey : null;
      }

      applyKlarna() {
        if (!this.purchaseAmount) return;
        this.querySelectorAll('klarna-placement').forEach((el) => {
          const key = this.klarnaKeyFor(el);
          if (key && el.getAttribute('data-key') !== key) el.setAttribute('data-key', key);
          if (el.getAttribute('data-purchase-amount') !== this.purchaseAmount) {
            el.setAttribute('data-purchase-amount', this.purchaseAmount);
          }
        });
      }

      watchKlarna() {
        if (this.klarnaObserver || !window.MutationObserver) return;
        let scheduled = false;
        this.klarnaObserver = new MutationObserver((mutations) => {
          const relevant = mutations.some(
            (m) =>
              (m.type === 'attributes' && m.target.tagName === 'KLARNA-PLACEMENT') ||
              (m.type === 'childList' && Array.from(m.addedNodes).some((n) => n.nodeType === 1 && (n.tagName === 'KLARNA-PLACEMENT' || (n.querySelector && n.querySelector('klarna-placement')))))
          );
          if (!relevant || scheduled) return;
          scheduled = true;
          setTimeout(() => {
            scheduled = false;
            this.klarnaCorrections += 1;
            if (this.klarnaCorrections > 20) return; // Bremse
            this.applyKlarna();
          }, 0);
        });
        this.klarnaObserver.observe(this, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-purchase-amount', 'data-key'],
        });
      }

      // Mit Auswahl: genauer Preis und Ersparnis-Badge des gewählten Stücks
      showUnitPrice(data) {
        const text = this.querySelector('[data-price-text]');
        if (text) text.innerHTML = data.priceHtml || '';
        const badge = this.querySelector('[data-price-badge]');
        if (!badge) return;
        const compare = Number(data.compare) || 0;
        if (compare <= data.price) {
          badge.hidden = true;
          return;
        }
        const escape = (value) => {
          const div = document.createElement('div');
          div.textContent = value;
          return div.innerHTML;
        };
        const pct = Math.round(((compare - data.price) * 100) / compare);
        badge.innerHTML = escape(this.dataset.savingsFormat || '')
          .replace('[percent]', pct)
          .replace('[amount]', data.saveHtml || '')
          .replace('[compare]', `<s>${data.compareHtml || ''}</s>`);
        badge.hidden = false;
      }

      select(unit) {
        if (!unit) return;
        this.current = unit;
        if (unit.input && !unit.input.checked) unit.input.checked = true;
        const data = unit.data;

        this.querySelectorAll('[data-variant-input]').forEach((input) => {
          input.value = data.variantId;
        });

        this.querySelectorAll('[data-unit-link]').forEach((link) => {
          link.href = data.url;
          link.removeAttribute('aria-disabled');
        });

        this.setPurchaseAmount(data.price);

        this.showUnitPrice(data);
        this.updateBuyState();
        this.renderInfobox(data);
        this.renderDescription(unit);
        this.loadGallery(data);
        this.dispatchEvent(new CustomEvent('model-collection:unit-change', { bubbles: true, detail: data }));
      }

      /*
        Beschreibung am Ende der Section: HTML-Beschreibung des gewählten Einzelstücks
        (aus dessen <template data-unit-description>), sonst die Kollektionsbeschreibung. Ohne Inhalt wird der Container ausgeblendet.
      */
      renderDescription(unit) {
        const box = this.querySelector('[data-model-description]');
        if (!box) return;
        const own = unit ? unit.el.querySelector('[data-unit-description]') : null;
        const fallback = this.querySelector('[data-description-default]');
        const source = own && own.innerHTML.trim() ? own : fallback;
        box.replaceChildren(source ? source.content.cloneNode(true) : '');
        box.hidden = !box.textContent.trim() && !box.querySelector('img, video, iframe');
      }

      updateBuyState() {
        const available = Boolean(this.current && this.current.data.available);
        const buttons = [this.querySelector('[data-add-button]'), this.querySelector('[data-add-button-mobile]')];
        const main = buttons[0];
        if (!main) return;
        let label = main.dataset.labelChoose || main.dataset.labelAdd;
        if (this.current) label = available ? main.dataset.labelAdd : main.dataset.labelSoldOut;
        buttons.forEach((button) => {
          if (!button) return;
          button.disabled = !available;
          const text = button.querySelector('[data-add-text], [data-add-text-mobile]');
          if (text) text.textContent = label;
        });
      }

      /* ---------- Galerie ---------- */
      bindGallery() {
        this.gallery = this.querySelector('[data-gallery]');
        if (!this.gallery) return;
        this.track = this.gallery.querySelector('[data-gallery-track]');
        this.thumbs = this.gallery.querySelector('[data-gallery-thumbs]');
        this.galleryNav = this.gallery.querySelector('[data-gallery-nav]');
        this.maxMedia = parseInt(this.gallery.dataset.maxMedia, 10) || 30;
        this.activeIndex = 0;

        const prev = this.gallery.querySelector('[data-gallery-prev]');
        const next = this.gallery.querySelector('[data-gallery-next]');
        if (prev) prev.addEventListener('click', () => this.goTo(this.activeIndex - 1));
        if (next) next.addEventListener('click', () => this.goTo(this.activeIndex + 1));

        if (this.thumbs) {
          this.thumbs.addEventListener('click', (event) => {
            const thumb = event.target.closest('[data-thumb-index]');
            if (thumb) this.goTo(parseInt(thumb.dataset.thumbIndex, 10));
          });
        }

        let frame;
        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => this.syncIndex());
          },
          { passive: true }
        );

        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.activeIndex + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.activeIndex - 1);
          }
        });
        this.updateCounter();
      }

      get scrollBehavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      goTo(index) {
        if (!this.track) return;
        const slides = this.track.children;
        if (!slides.length) return;
        const target = (index + slides.length) % slides.length;
        this.track.scrollTo({ left: slides[target].offsetLeft, behavior: this.scrollBehavior });
        this.setActive(target);
      }

      syncIndex() {
        const width = this.track.clientWidth;
        if (!width) return;
        const index = Math.round(this.track.scrollLeft / width);
        if (index !== this.activeIndex) this.setActive(index);
      }

      updateCounter() {
        const counter = this.gallery && this.gallery.querySelector('[data-gallery-counter]');
        if (!counter || !this.track) return;
        const total = this.track.children.length;
        counter.hidden = total < 2;
        counter.textContent = `${(this.activeIndex || 0) + 1} / ${total}`;
      }

      setActive(index) {
        this.activeIndex = index;
        this.updateCounter();
        if (!this.thumbs) return;
        Array.from(this.thumbs.children).forEach((thumb, i) => {
          if (i === index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        const thumb = this.thumbs.children[index];
        if (thumb) {
          const left = thumb.offsetLeft - (this.thumbs.clientWidth - thumb.clientWidth) / 2;
          this.thumbs.scrollTo({ left, behavior: this.scrollBehavior });
        }
      }

      sizedUrl(src, width) {
        try {
          const url = new URL(src, window.location.href);
          url.searchParams.set('width', width);
          return url.toString();
        } catch (e) {
          return src;
        }
      }

      buildImage(media, width, widths, sizes, alt, eager) {
        const img = document.createElement('img');
        img.src = this.sizedUrl(media.src, width);
        img.srcset = widths.map((w) => `${this.sizedUrl(media.src, w)} ${w}w`).join(', ');
        img.sizes = sizes;
        img.alt = alt;
        img.loading = eager ? 'eager' : 'lazy';
        img.decoding = 'async';
        if (media.width && media.height) {
          img.width = media.width;
          img.height = media.height;
        }
        return img;
      }

      renderGallery(media, title) {
        if (!this.track) return;
        const sizes = this.track.dataset.sizes || '100vw';
        const total = media.length;

        const slides = media.map((item, i) => {
          const slide = document.createElement('div');
          slide.className = 'model-gallery__slide';
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', `${i + 1} / ${total}`);
          slide.appendChild(
            this.buildImage(item, 1000, [400, 600, 800, 1000, 1200, 1500], sizes, item.alt || title, i === 0)
          );
          return slide;
        });
        this.track.replaceChildren(...slides);
        this.track.scrollLeft = 0;

        if (this.thumbs) {
          const thumbs = media.map((item, i) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'model-gallery__thumb';
            button.dataset.thumbIndex = i;
            button.setAttribute('aria-label', `${i + 1} / ${total}`);
            button.appendChild(this.buildImage(item, 200, [100, 160, 200], '8rem', '', false));
            return button;
          });
          this.thumbs.replaceChildren(...thumbs);
          this.thumbs.scrollLeft = 0;
        }
        if (this.galleryNav) this.galleryNav.hidden = total < 2;
        this.setActive(0);
      }

      mapProductMedia(product) {
        const media = (product.media || [])
          .map((m) => {
            const image = m.media_type === 'image' ? m : m.preview_image;
            if (!image || !image.src) return null;
            return { src: image.src, alt: m.alt || product.title, width: image.width, height: image.height };
          })
          .filter(Boolean);
        if (!media.length && Array.isArray(product.images)) {
          product.images.forEach((src) => media.push({ src, alt: product.title }));
        }
        return media.slice(0, this.maxMedia);
      }

      fetchMedia(data) {
        if (this.mediaCache.has(data.id)) return Promise.resolve(this.mediaCache.get(data.id));
        if (!this.pending) this.pending = new Map();
        if (this.pending.has(data.id)) return this.pending.get(data.id);
        const request = fetch(data.jsUrl, { headers: { Accept: 'application/json' } })
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.json();
          })
          .then((product) => {
            const media = this.mapProductMedia(product);
            this.mediaCache.set(data.id, media);
            return media;
          })
          .finally(() => this.pending.delete(data.id));
        this.pending.set(data.id, request);
        return request;
      }

      prefetch(data) {
        if (!data || !data.jsUrl || data.id === this.galleryProductId) return;
        this.fetchMedia(data).catch(() => {});
      }

      loadGallery(data) {
        if (!this.track || !data || this.galleryProductId === data.id) return;
        this.galleryProductId = data.id;

        const cached = this.mediaCache.get(data.id);
        if (cached && cached.length) {
          this.renderGallery(cached, data.title);
          return;
        }

        // Sofort das Kartenbild zeigen, dann alle Bilder nachladen.
        if (data.image) {
          this.renderGallery(
            [{ src: data.image, alt: data.title, width: data.imageWidth, height: data.imageHeight }],
            data.title
          );
        }
        if (!data.jsUrl) return;
        this.gallery.classList.add('is-loading');
        this.fetchMedia(data)
          .then((media) => {
            if (this.galleryProductId === data.id && media.length) this.renderGallery(media, data.title);
          })
          .catch(() => {})
          .finally(() => this.gallery.classList.remove('is-loading'));
      }
    }

    customElements.define('model-collection', ModelCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
